import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

export const sendSubject: (
  options: AxiosRequestConfig,
  path: string,
) => void = (options, path) => {
  return axios(options)
    .then((res: AxiosResponse) => {
      if (res.status === 200) {
        location.href = path;
      } else {
        console.log(res);
      }
    })
    .catch((err: AxiosError) => {
      location.href = path;
      console.log(err);
    });
};
